import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { TriStateCheckBoxComponent } from '@myapp/features/widgets/components';
import { AuthorizationService } from '@myapp/modules/fwcore/services';
import { KENDO_SVGICON } from "@progress/kendo-angular-icons";
import { CheckBoxModule, TextBoxModule } from "@progress/kendo-angular-inputs";
import { KENDO_LISTVIEW } from '@progress/kendo-angular-listview';

import { Component, OnChanges, OnDestroy, SimpleChanges, ViewEncapsulation } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AdminService } from "../../services/admin.service";
import { ControlResizerService } from "../../../../../services/framework/control-resizer.service";
import { InstanceConfigurationService } from "../../services/InstanceConfiguration.service";
import { ExcelModule, GridModule } from "@progress/kendo-angular-grid";
import { DropDownListModule } from "@progress/kendo-angular-dropdowns";
import { BaseGridComponent } from "../../components/base-grid/base-grid.component";
import { IInstanceConfiguration } from "../../models/future-deprecation/IInstanceConfiguration";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { v4 as uuidv4 } from 'uuid';
import { InstanceEditorComponent } from "../../components/instance-configuration/instance-configuration-editor.component";
import { InstanceConfigForm } from "../../components/instance-configuration/instance-configuration.form";
import { InstanceFilter } from "../../components/instance-configuration/instance-configuration.filter";

@Component({
  selector: 'app-instance-list',
  standalone: true,
  imports: [CommonModule, TextBoxModule, FormsModule, TriStateCheckBoxComponent, CheckBoxModule, KENDO_SVGICON, KENDO_LISTVIEW, GridModule, ExcelModule, DropDownListModule],
  templateUrl: './instance-list.component.html',
  styleUrls: ['./instance-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class InstanceListComponent extends BaseGridComponent <IInstanceConfiguration > {

  

  constructor(protected instanceConfigurationService: InstanceConfigurationService, adminService: AdminService, modalService: NgbModal)  {
    super(adminService, modalService);
    this.filter = new InstanceFilter();
    this.retrieveInstanceConfiguration();
  }

  retrieveItems(): void {
    this.retrieveInstanceConfiguration();
  }
  refreshItems(): void {
    this.retrieveInstanceConfiguration();
  }
  saveItem(item: IInstanceConfiguration, isNew: boolean): void {

    this.instanceConfigurationService.upsertInstanceConfigurationItem(item, isNew)
      .subscribe(
        _response => {
          this.refreshItems();
        },
        error => {
          // Raise Error
          console.error(error);
        });
  }
  public addHandler({ sender }: any) {


    var instanceObj: IInstanceConfiguration = {
      id: uuidv4(),
      clientName: '',
      oktaClientId: '',
      gxURL: '',
      gxKey: '',
      gxPassword: '',
      databaseConnectionString: '',
      powerBIURL:''
    };
    

    const size = 'lg';
    const options = {
      title: "Add New Instance", windowClass: "modal-preferences",
      showSave: true, showCancel: true, showCross: true, scrollable: false, saveText: 'Add'
    };

    this.showEditorModal(size, options, InstanceEditorComponent, new InstanceConfigForm(instanceObj), true);
  }
  public editHandler({ sender, rowIndex, dataItem }: any) {
    const size = 'lg';
    const options = {
      title: "Edit User", windowClass: "modal-preferences",
      showSave: true, showCancel: true, showCross: true, scrollable: false
    };

    this.showEditorModal(size, options, InstanceEditorComponent, new InstanceConfigForm(dataItem), true);
  }

  public removeHandler({ dataItem }: any): void {
    this.instanceConfigurationService.deleteInstanceConfigurationItem(dataItem)
      .subscribe(
        _response => {
          this.refreshItems();
        },
        error => {          
          console.error(error);
        });
  }


  upsertInstanceConfigurationItem(): void {
   
    let newInstanceId = uuidv4();
    var instanceObj: IInstanceConfiguration = {
      id: newInstanceId,
      clientName: 'test1',
      oktaClientId: 'test 2',
      gxURL: 'test 3',
      gxKey: 'test 4',
      gxPassword: 'test 5'
    };

    this.instanceConfigurationService.upsertInstanceConfigurationItem(instanceObj,true)
      .subscribe(
        data => {
          alert(data)
        });
  }

  retrieveInstanceConfiguration(): void {
    this.instanceConfigurationService.getAlInstanceConfiguration()
      .subscribe(
        data => {        
          this.items = data;
          this.filteredItems = this.items;          
        });
  }
}

